import apiempresaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('grupo/tablet', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    async findDetalhado() {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('grupo/detalhado'),
      ]);

      return data;
    },

    async create(_, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.post('grupo/app', body),
      ]);

      return data;
    },

    async update(_, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.put(`grupo/app/${body.id}`, body),
      ]);

      return data;
    },

    async delete(_, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.delete(`grupo/app/${body.id}`, body),
      ]);

      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
